module.exports = __webpack_public_path__ + "static/media/2_en.89f692f8.png";